export function waitMs<T = undefined>(ms: number, value: T) {
  return new Promise<T>((resolve) => {
    setTimeout(() => {
      resolve(value);
    }, ms);
  });
}
